/** Gift-finder product tags — normalized slug list on each product. */

export function normalizeGiftTagSlug(raw) {
  return String(raw || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9-]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

/**
 * @param {unknown} raw — array or comma/newline string
 * @returns {string[]}
 */
export function normalizeProductGiftTags(raw) {
  let parts = [];
  if (Array.isArray(raw)) {
    parts = raw;
  } else if (typeof raw === 'string' && raw.trim()) {
    parts = raw.split(/[,;\n]+/);
  }
  const out = new Set();
  for (const t of parts) {
    const s = normalizeGiftTagSlug(t);
    if (s && s !== 'all') out.add(s);
  }
  return [...out];
}

/** @param {object} product */
export function productGiftTags(product) {
  return normalizeProductGiftTags(product?.gift_tags);
}

/** @param {object} product @param {string} tagSlug */
export function productHasGiftTag(product, tagSlug) {
  const t = normalizeGiftTagSlug(tagSlug);
  if (!t) return false;
  return productGiftTags(product).includes(t);
}

/** @param {object} product @param {string[]} tagSlugs */
export function productMatchesAnyGiftTag(product, tagSlugs) {
  const want = (tagSlugs || []).map(normalizeGiftTagSlug).filter(Boolean);
  if (!want.length) return true;
  const have = new Set(productGiftTags(product));
  return want.some((t) => have.has(t));
}
